import React from "react";
import { useSelector } from "react-redux";

import { useTranslation } from "hooks";
import { selectProductFormData } from "store/app";
import { Modal } from "components/Modals";
import SkateCustomiseBladeModalContent from "./SkateCustomiseBladeModalContent";

export default function SkateCustomiseBladeModal({
  outerTitle,
  title,
  bladeImage,
  customiseFeeNote,
  bladeImageForPersonalisation,
  cancelButtonLabel,
  submitButtonLabel,
  fields = [],
  onClose,
}) {
  const { t } = useTranslation();
  const productFormData = useSelector(selectProductFormData);

  return (
    <Modal
      appLogo={productFormData?.appLogo}
      outerTitle={outerTitle}
      onClose={onClose}
      closeButtonLabel={t("CLOSE")}
      isTopMostModal
    >
      {({ close }) => (
        <SkateCustomiseBladeModalContent
          title={title}
          bladeImage={bladeImage}
          bladeImageForPersonalisation={bladeImageForPersonalisation}
          fields={fields}
          customiseFeeNote={customiseFeeNote}
          cancelButtonLabel={cancelButtonLabel}
          submitButtonLabel={submitButtonLabel}
          close={close}
        />
      )}
    </Modal>
  );
}
